export enum StaffHealthTabsIndex {
    StaffMedicalConditions,
    StaffHealthVisitLog
}

export class StaffMedicalCondition {
    Id: number;
    DateConditionStarted: Date;
    DateConditionEnded: Date;
    GenerateAlert: boolean;
    NonNurseViewable: boolean;
    MedicalConditionCodeId: number;
    Comment: string;
    MedicalConditionCode: string;
    MedicalConditionDescription: string;
    Note: string;
}

export class StaffHealthVisitLog {
    Id: number;
    DateVisit: Date;
    DOHSurveillanceId: number;
    Reason: string;
    TimeIn: string;
    TimeOut: string;
    CallMadeTo: string;
    InjuryMajor: boolean;
    InjuryMinor: boolean;
    Referral: boolean;
    Report: boolean;
    Illness: boolean;
    EMSCall: boolean;
    Treated: boolean;
    NoticeSent: boolean;
    AEDUsed: boolean;
    ReferralReturnedToSchool: boolean;
    Temperature: number;
    UserName: string;
    ICD9: string;
    EvaluationOfClinicVisit: string;
    Comments: string;
    Glucose: string;
    Units: string;
    Carb: string;
    BloodPressure: string;
    OnDutyUserId: number;
    SelectedCodeTreatmentIds: string;
    DateReferralReturned: Date;
    ClinicVisitLogCodeId: number;
    Site: string;
    LastUpdatedByUserName: string;
    LastUpdatedDate: Date;
    NatureOfInjuryId: number;
    TimePeriodOfInjuryId: number;
    LocationOfInjuryId: number;
    Pulse: string;
    Respiration: string;
    SpO2: string;

    // Non DTO Field //
    TreatmentIds: string [] = [];
    selectedTreatments: string;
}

export class ClinicVisitLogCodes {
    ClinicVisitCodeId: number;
    ClinicVisitCode: string;
    ClinicVisitCodeDescription: string;
    ClinicVisitDescription: string;
}

export class MedicalUsers {
    OnDutyUserId: number;
    UserName: string;
    OnDutyUserFullName: string;
}

export class MedicalCodeTreatment {
    Id: number;
    Code: string;
    Description: string;
    SequenceNumber: number;
    Inactive: boolean;
}
